import React,{useEffect} from "react";
import * as S from './FaqPageStyles';
import FaqSectionComp from "./components/FaqSectionComp";
import { getLoadedComponent } from "../../config/omni";

const FaqPage = () => {
  useEffect(()=>{
    getLoadedComponent('FaqPage')
  },[])

  return (
    <S.FaqWrapper>
      <FaqSectionComp />
    </S.FaqWrapper>
  );
};

export default React.memo(FaqPage);

